module.exports = "<div class=\"m-2 row\">\r\n\tNOT IMPLEMENTED\r\n</div>\r\n<router-outlet></router-outlet>\r\n"